export const TransactionStatusEnum = {
  Approved: 'Approved',
  Pending: 'Pending',
  Declined: 'Declined',
} as const;
export type TransactionStatusEnum = (typeof TransactionStatusEnum)[keyof typeof TransactionStatusEnum];
